
import { Language } from './types';

export const translations: Record<Language, any> = {
  fr: {
    header_subtitle: "LE CRÉATEUR AVANT/APRÈS ULTIME",
    media_config: "Configuration des Médias",
    image_before: "Image Avant",
    image_after: "Image Après",
    layout_format: "Mise en Page & Format",
    view_mode: "Mode d'affichage",
    orientation: "Orientation",
    image_fit: "Format Image",
    corner_radius: "Bords Arrondis Images",
    padding: "Padding Images",
    styles_themes: "Styles & Thèmes",
    separator_design: "Design du Séparateur",
    color: "Couleur",
    thickness: "Épaisseur",
    texts_captions: "Textes & Légendes",
    main_title: "Titre Principal",
    before_label_caption: "Avant : Label & Légende",
    after_label_caption: "Après : Label & Légende",
    font: "Police",
    font_size: "Taille Police",
    label_color: "Couleur des Labels",
    desc_color: "Couleur des Descriptions",
    download_btn: "TÉLÉCHARGER LE VISUEL",
    copy_code_btn: "COPIER LE CODE HTML",
    copy_link_btn: "COPIER LE LIEN DE PARTAGE",
    create_yours: "CRÉER LE MIEN",
    export_mode: "Mode d'Exportation",
    export_mode_image: "Image (PNG)",
    export_mode_dynamic: "Web (HTML)",
    export_mode_link: "Lien (Partage)",
    code_copied: "Code copié dans le presse-papier !",
    link_copied: "Lien de partage copié !",
    exporting: "EXPORTATION...",
    tip: "Astuce : Déplacez les étiquettes et le curseur central à la main pour composer votre scène.",
    click_to_upload: "Cliquer pour uploader",
    horiz: "Horiz",
    vert: "Vert",
    side: "Côte à côte",
    slider: "Curseur",
    cover: "Remplir",
    contain: "Ajuster",
    default_title: "EXPÉRIENCE NATURE",
    default_before_label: "Nature Originale",
    default_after_label: "Vision Retouchée",
    default_before_desc: "Photographie brute capturée au lever du soleil sans filtres.",
    default_after_desc: "Post-traitement accentuant les contrastes et la saturation.",
    buy_me_coffee: "M'offrir un café"
  },
  en: {
    header_subtitle: "THE ULTIMATE BEFORE/AFTER CREATOR",
    media_config: "Media Configuration",
    image_before: "Before Image",
    image_after: "After Image",
    layout_format: "Layout & Format",
    view_mode: "View Mode",
    orientation: "Orientation",
    image_fit: "Image Fit",
    corner_radius: "Image Corner Radius",
    padding: "Image Padding",
    styles_themes: "Styles & Themes",
    separator_design: "Separator Design",
    color: "Color",
    thickness: "Thickness",
    texts_captions: "Texts & Captions",
    main_title: "Main Title",
    before_label_caption: "Before: Label & Caption",
    after_label_caption: "After: Label & Caption",
    font: "Font",
    font_size: "Font Size",
    label_color: "Label Color",
    desc_color: "Description Color",
    download_btn: "DOWNLOAD VISUAL",
    copy_code_btn: "COPY HTML CODE",
    copy_link_btn: "COPY SHARE LINK",
    create_yours: "CREATE MINE",
    export_mode: "Export Mode",
    export_mode_image: "Image (PNG)",
    export_mode_dynamic: "Web (HTML)",
    export_mode_link: "Link (Share)",
    code_copied: "Code copied to clipboard!",
    link_copied: "Share link copied!",
    exporting: "EXPORTING...",
    tip: "Tip: Drag labels and the central slider by hand to compose your scene.",
    click_to_upload: "Click to upload",
    horiz: "Horiz",
    vert: "Vert",
    side: "Side by Side",
    slider: "Slider",
    cover: "Cover",
    contain: "Contain",
    default_title: "NATURE EXPERIENCE",
    default_before_label: "Original Nature",
    default_after_label: "Retouched Vision",
    default_before_desc: "Raw photography captured at sunrise without any filters.",
    default_after_desc: "Post-processing emphasizing contrast and saturation.",
    buy_me_coffee: "Buy me a coffee"
  },
  es: {
    header_subtitle: "EL CREADOR ANTES/DESPUÉS DEFINITIVO",
    media_config: "Configuración de Medios",
    image_before: "Imagen Antes",
    image_after: "Imagen Después",
    layout_format: "Diseño y Formato",
    view_mode: "Modo de Visualización",
    orientation: "Orientación",
    image_fit: "Ajuste de Imagen",
    corner_radius: "Radio de Esquina",
    padding: "Padding de Imagen",
    styles_themes: "Estilos y Temas",
    separator_design: "Diseño del Separador",
    color: "Color",
    thickness: "Grosor",
    texts_captions: "Textos y Leyendas",
    main_title: "Título Principal",
    before_label_caption: "Antes: Etiqueta y Leyenda",
    after_label_caption: "Después: Etiqueta y Leyenda",
    font: "Fuente",
    font_size: "Tamaño de Fuente",
    label_color: "Color de Etiquetas",
    desc_color: "Color de Descripciones",
    download_btn: "DESCARGAR VISUAL",
    copy_code_btn: "COPIAR CÓDIGO HTML",
    copy_link_btn: "COPIAR ENLACE",
    create_yours: "CREAR EL MÍO",
    export_mode: "Modo de Exportación",
    export_mode_image: "Imagen (PNG)",
    export_mode_dynamic: "Web (HTML)",
    export_mode_link: "Enlace (Compartir)",
    code_copied: "¡Código copiado al portapapeles!",
    link_copied: "¡Enlace compartido copiado!",
    exporting: "EXPORTANDO...",
    tip: "Consejo: Arrastre las etiquetas y el deslizador central manualmente para componer su escena.",
    click_to_upload: "Haga clic para subir",
    horiz: "Horiz",
    vert: "Vert",
    side: "Lado a lado",
    slider: "Deslizador",
    cover: "Cubrir",
    contain: "Contener",
    default_title: "EXPERIENCIA NATURAL",
    default_before_label: "Naturaleza Original",
    default_after_label: "Visión Retocada",
    default_before_desc: "Fotografía en bruto capturada al amanecer sin filtros.",
    default_after_desc: "Post-procesamiento que acentúa los contrastes et la saturación.",
    buy_me_coffee: "Cómprame un café"
  }
};
